/* eslint-disable @typescript-eslint/no-inferrable-types */
import { SmBaseEntity } from "src/modules/sm-base/shared/sm-base-entity.model";
import { Column, Entity, ManyToOne } from "typeorm";
import { ProductInformation } from "./productInformation.entity";

@Entity()
export class AllergensProductInformation extends SmBaseEntity {
    @Column()
    name: string;

    @Column()
    status: string = "";

    @Column()
    wfId: string;

    @ManyToOne((_type) => ProductInformation, productInfo => productInfo.additives)
    product: ProductInformation;
}